export enum CameraType {
  Perspective,
  Orthographic,
  FPVCamera,
}
